import React, { useEffect, useState } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AdminSidebar from "../Side/AdminSidebar";
import AdunitTable from "../Dashboards/AdunitTable";
import { useAuth } from '../Auth/AuthContext';
import AdscodeTable from "../Dashboards/AdscodeTable";

const Adscode = () => {
    const Auth = useAuth();
    const admin = Auth.authState.roles === "Admin";

    return (
        <div className="mt-6">
            <AdscodeTable />
        </div>
    );
};

export default Adscode;
